export default {
  joy: '#8bc34a',
  anger: '#ff8a65',
  fear: '#03a9f4',
  grief: '#e938ff',
};